export class Rental {
  static readonly Directions = {
    IN: 'in',
    OUT: 'out',
  };
}
